export enum AnalyticsDevFlag {
  HrCustomFields = 'hr_custom_fields',

  HrDetails = 'hr_details',

  HrDashboardTemplates = 'hr_dashboard_templates',
}

export type AnalyticsDevFlagsMap = Record<AnalyticsDevFlag, boolean>;

export type AnalyticsDevFlagsFetchResponse = {
  features: AnalyticsDevFlag[];
};
